function AnnouncementListController() {
    this.constructor.apply(this, arguments);
}

AnnouncementListController.$inject = ['$scope', '$Loading', 'AnnouncementService', '$state', '$q', 'DeviceService', 'AuthService'];
AnnouncementListController.prototype = {
    /**
     * @param $scope {angular.IScope}
     * @param $Loading {$Loading}
     * @param AnnouncementService {AnnouncementService}
     * @param $state {angular.ui.IStateService}
     * @param $q {angular.IQService}
     * @param DeviceService {DeviceService}
     * @param AuthService {AuthService}
     *
     */
    constructor($scope, $Loading, AnnouncementService, $state, $q, DeviceService, AuthService) {
        this.$scope = $scope;
        this.$Loading = $Loading;
        this.announcementService = AnnouncementService;
        this.$state = $state;
        this.$q = $q;
        this.deviceService = DeviceService;
        this.authService = AuthService;

        /** @type IAnnouncement[] */
        this.list = null;

        /** @type number*/
        this.announcements = this.authService.getAuthenticatedUser().Announcements||0;

        this.getActiveAnnouncements().finally(this.$Loading.blockUI());

        // Go back when press escape/back button
        this.deviceService.onGoBackButton(this.$scope, this.goBack.bind(this));
    },

    /**
     * Navigates back to the home page.
     */
    goBack: function () {
        this.$state.go('internal.home');
    },

    /**
     *
     * @returns {angular.IPromise<IAnnouncement[]>}
     */
    getActiveAnnouncements() {
        return this.announcementService.getActiveAnnouncements().then((list) => {
            this.announcements = list.length;
            this.list = list;
            return this.$q.resolve(list)
        });
    },
    doRefresh() {
        return this.getActiveAnnouncements();
    },

    /**
     *
     * @param item {IAnnouncement}
     * @param $event {MouseEvent}
     */
    viewAnnouncementDetails(item, $event) {
        $event.preventDefault();
        this.announcementService.gotToDetails(item);
    }

}
angular.module('internal.announcements').controller('AnnouncementListController', AnnouncementListController);